import {Injectable} from '@angular/core';
import {Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';

import {Question} from 'shared/models/questions/question';
import {TreeListRepository} from './../repositories/tree-list.repository';

@Injectable()
export class TreeListService {

  constructor(private treelistRepository: TreeListRepository) { }

  public getRootQuestions(): Observable<Array<Question>> {
    return this.treelistRepository.getRootQuestions();
  }

  public deleteTree(id: string): Observable<Response> {
    return this.treelistRepository.deleteTree(id);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/dynamic-tips/tree-list/services/tree-list.service.ts